module.exports = __webpack_public_path__ + "static/media/check.f626bf02.svg";